const password = {
    unsupported_encryption_method: 'طريقة التشفير {{name}} غير مدعومة.',
    pepper_not_found: 'رمز تشفير كلمة المرور غير موجود. يرجى التحقق من البيئة الأساسية الخاصة بك.',
    rejected: 'تم رفض كلمة المرور. يرجى التحقق مما إذا كانت كلمة المرور تلبي المتطلبات.',
};
export default Object.freeze(password);
